import Phaser from 'phaser';
import MenuScene from './scenes/MenuScene';
import SettingsScene from './scenes/SettingsScene';
import { PoolScene } from './scenes/PoolScene';
import { BoardScene } from './scenes/BoardScene';
import { GameOverScene } from './scenes/GameOverScene';
import { MultiplayerManager } from './multiplayer/managers/MultiplayerManager';
import { NetworkSync } from './multiplayer/services/NetworkSync';
import { GameSession } from './multiplayer/services/GameSession';
import { ShareCodeInput } from './ui/components/ShareCodeInput';
import { GameLobby } from './ui/components/GameLobby';

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  width: 1280,
  height: 720,
  parent: 'game-container',
  backgroundColor: '#1a1a1a',
  antialias: true,
  roundPixels: false,
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  physics: {
    default: 'matter',
    matter: {
      debug: false,
      gravity: { x: 0, y: 1 },
    },
  },
  scene: [MenuScene, SettingsScene, PoolScene, BoardScene, GameOverScene],
};

// Create and export the game instance
export const game = new Phaser.Game(config);

// For debugging in browser console
if (typeof window !== 'undefined') {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any).game = game;
  
  // Expose multiplayer classes for testing
  (window as any).MultiplayerManager = MultiplayerManager;
  (window as any).NetworkSync = NetworkSync;
  (window as any).GameSession = GameSession;
  (window as any).ShareCodeInput = ShareCodeInput;
  (window as any).GameLobby = GameLobby;
  
  console.log('🎮 RollWords loaded! Available for testing:');
  console.log('- window.game (Phaser game instance)');
  console.log('- window.MultiplayerManager (for multiplayer testing)');
  console.log('- window.NetworkSync (WebSocket service)');
  console.log('- window.GameSession (session management)');
  console.log('- window.ShareCodeInput (join dialog)');
  console.log('- window.GameLobby (lobby UI)');
}
